import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../nav_bar/Navbar";
import "./clientEvent.css";

import {
  fetchAllEvents
} from "./clientEventService";

/**
 * ===============================
 * DEBUG LOGGER (SAFE FOR PROD)
 * ===============================
 */

const isDev = process.env.NODE_ENV === "development";

const debugLog = (...args) => {
  if (isDev) console.log("[EventListPage]", ...args);
};

const debugWarn = (...args) => {
  if (isDev) console.warn("[EventListPage]", ...args);
};

const debugError = (...args) => {
  if (isDev) console.error("[EventListPage]", ...args);
};



const EventListPage = () => {

  const navigate = useNavigate();

  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isLoggedIn, setIsLoggedIn] = useState(false);



  /**
   * ===============================
   * CHECK USER LOGIN STATUS
   * ===============================
   */

  useEffect(() => {

    try {

      const storedUser = localStorage.getItem("user");
      const token = localStorage.getItem("token");

      if (storedUser && token) {

        debugLog("User is logged in");

        setIsLoggedIn(true);

      } else {

        debugLog("User is NOT logged in");

        setIsLoggedIn(false);

      }

    } catch (error) {

      debugError("Error checking login:", error);
      setIsLoggedIn(false);

    }

  }, []);



  /**
   * ===============================
   * NAVIGATE TO MY BOOKINGS
   * ===============================
   */

  const handleMyBookingsClick = () => {

    debugLog("My Bookings clicked");

    if (isLoggedIn) {

      debugLog("User logged in → navigating to My Bookings");

      navigate("/my-bookings");

    } else {

      debugWarn("User not logged in → redirecting to Register");

      navigate("/my-bookings");

    }

  };



  /**
   * ===============================
   * DATE FORMAT HELPERS
   * ===============================
   */

  const formatDateSafe = (value) => {

    try {

      if (!value) return "-";

      const date = new Date(value);

      if (isNaN(date.getTime())) {
        debugWarn("Invalid date:", value);
        return value;
      }

      return date.toLocaleDateString("en-IN", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
      });

    } catch (e) {

      debugError("formatDateSafe error:", e);
      return value;

    }

  };


  const formatTimeSafe = (value) => {

    try {

      if (!value) return "-";

      const date = new Date(value);

      if (isNaN(date.getTime())) {
        debugWarn("Invalid time:", value);
        return value;
      }

      return date.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true
      });

    } catch (e) {

      debugError("formatTimeSafe error:", e);
      return value;

    }

  };



  /**
   * ===============================
   * LOAD EVENTS
   * ===============================
   */

  useEffect(() => {

    debugLog("Component mounted");

    loadEvents();

  }, []);



  const loadEvents = async () => {

    try {

      setLoading(true);

      const response = await fetchAllEvents();

      debugLog("Events response:", response);

      if (response.status === 200) {

        setEvents(response.data);

      } else {

        debugWarn("API error:", response.message);

      }

    } catch (e) {

      debugError(e);

    } finally {

      setLoading(false);

    }

  };



  /**
   * ===============================
   * NAVIGATE TO BOOKING PAGE
   * ===============================
   */

  const handleBookClick = (event) => {

    if (event.cancelled) {

    debugWarn("Cancelled event cannot be booked:", event.id);
    return;

  }


    debugLog("Navigating to booking page:", event);

    navigate(`/booking/${event.id}`, {
      state: { event }
    });

  };



  /**
   * ===============================
   * EVENT LIST UI
   * ===============================
   */

  const renderEvents = () => (

    <div className="event-row">

      {events.map(event => (

        <div key={event.id} className="event-card">

          <h3>{event.title}</h3>

          <p className="description">
            {event.description}
          </p>

          <p>
            <strong>Date:</strong><br/>
            {formatDateSafe(event.eventStartTime)}
          </p>

          <p>
            <strong>Time:</strong><br/>
            {formatTimeSafe(event.eventStartTime)}
          </p>

          <p>
            <strong>Duration:</strong><br/>
            {event.eventDuration} minutes
          </p>

          <button
            className="book-btn"
            onClick={() => handleBookClick(event)}
          >
            Book Now
          </button>

        </div>

      ))}

    </div>

  );



  /**
   * ===============================
   * MAIN UI
   * ===============================
   */

return (

<> <Navbar />

  <div className="client-container">

    {/* HEADER */}
    <div className="client-header">

  <div className="header-left">
    <h1 className="page-title">Available Events</h1>
    <p className="page-subtitle">
      Join live speaking practice sessions
    </p>
  </div>

  <div className="header-right">
    <button
      className="my-bookings-btn"
      onClick={handleMyBookingsClick}
    >
      My Bookings
    </button>
  </div>

</div>


    {/* LOADING */}
    {loading && (
      <div className="center">
        <div className="spinner"></div>
        <p>Loading events...</p>
      </div>
    )}


    {/* EMPTY */}
    {!loading && events.length === 0 && (
      <div className="center">
        <p className="empty-text">
          No events available right now
        </p>
      </div>
    )}


    {/* EVENTS */}
    {!loading && events.length > 0 && (

      <div className="event-grid">

        {events.map(event => (

          <div key={event.id} className="event-card">

            <div className="event-card-body">

              {event.cancelled && (
  <div className="cancelled-badge">
    Cancelled
  </div>
)}

              <h3 className="event-title">
                {event.title}
              </h3>

              <p className="event-description">
                {event.description}
              </p>


              <div className="event-info-modern">

  <div className="info-row-modern">

    <div className="info-left">
      <span className="info-icon">📅</span>
      <span className="info-label">Date</span>
    </div>

    <div className="info-value large">
      {formatDateSafe(event.eventStartTime)}
    </div>

  </div>


  <div className="info-row-modern">

    <div className="info-left">
      <span className="info-icon">⏰</span>
      <span className="info-label">Time</span>
    </div>

    <div className="info-value large">
      {formatTimeSafe(event.eventStartTime)}
    </div>

  </div>


  <div className="info-row-modern">

    <div className="info-left">
      <span className="info-icon">⏳</span>
      <span className="info-label">Duration</span>
    </div>

    <div className="info-value">
      {event.eventDuration} minutes
    </div>

  </div>

</div>

            </div>


            <button
  className={`book-btn ${event.cancelled ? "disabled-btn" : ""}`}
  onClick={() => handleBookClick(event)}
  disabled={event.cancelled}
>
  {event.cancelled ? "Event Cancelled" : "Book Now"}
</button>

          </div>

        ))}

      </div>

    )}

  </div>

  </>

);

};


export default EventListPage;